import { render, staticRenderFns } from "./buttonFile.vue?vue&type=template&id=75838f2a&scoped=true"
import script from "./buttonFile.vue?vue&type=script&lang=js"
export * from "./buttonFile.vue?vue&type=script&lang=js"
import style0 from "./buttonFile.vue?vue&type=style&index=0&id=75838f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75838f2a",
  null
  
)

export default component.exports